import { api } from '../api';
import { PhoneCompany } from '../../contexts/auth';

export async function getFullClients() {
    try {
        const { data } = await api.get(`/clients/company`)
        return data;
    }
    catch (error) {
        return null
    }
}

export async function getClients(number_client) {
    try {
        const { data } = await api.get(`/clients?number_client=${number_client}&number_key=${PhoneCompany()}`)
        return data;
    }
    catch (error) {
        return null
    }
}
export async function postClient(new_name, number_client) {
    const name_client = new_name.replace(" ", '%20')
    try {
        const { status } = await api.post(`/clients?name=${name_client}&number_client=${number_client}&number_key=${PhoneCompany()}`)
        if (status === 200) return true
        return false;
    }
    catch (error) {
        return false;
    }
}

export async function putClient(client_id, new_name, number_client) {
    const name_client = new_name.replace(" ", '%20')
    try {
        const { status } = await api.put(`/clients?id=${client_id}&name=${name_client}&number_client=${number_client}&number_key=${PhoneCompany()}`)
        if (status === 200) return true
        return false;
    }
    catch (error) {
        return false;
    }
}

export async function deleteClient(number_client) {
    try {
        const { status } = await api.delete(
            `/clients?number_client=${number_client}`
        )
        if (status === 200) return true
        return false;
    }
    catch (error) {
        return false;
    }
}